import Select, { SelectOption } from '@rio-cloud/rio-uikit/Select';
import { FunctionComponent, useCallback, useId } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Environment } from './dataQuery.types';

type ContextSelectionProps = {
    disabled?: boolean;
    environment: Environment;
    setEnvironment: (context: Environment) => void;
};

export const EnvironmentSelection: FunctionComponent<ContextSelectionProps> = ({
    disabled = false,
    environment,
    setEnvironment,
}) => {
    const intl = useIntl();
    const selectionId = useId();

    type EnvironmentOption = SelectOption & { id: Environment };

    const onSelectionChange = useCallback(
        (option: EnvironmentOption | undefined) => {
            if (option !== undefined) {
                setEnvironment(option?.id);
            }
        },
        [setEnvironment],
    );

    const options: EnvironmentOption[] = [
        {
            id: Environment.PROD,
            label: intl.formatMessage({ id: 'outboundOrderBook.inspector.dataquery.form.environment.prod' }),
        },
        {
            id: Environment.QA,
            label: intl.formatMessage({ id: 'outboundOrderBook.inspector.dataquery.form.environment.qa' }),
        },
    ];

    return (
        <div className="form-group">
            <label htmlFor={selectionId}>
                <FormattedMessage id="outboundOrderBook.inspector.dataquery.form.environment.label" />
            </label>
            <Select
                id={selectionId}
                dropdownClassName="max-height-400"
                options={options}
                disabled={disabled}
                value={environment !== undefined ? [environment] : undefined}
                onChange={onSelectionChange}
            />
        </div>
    );
};
